import { $api } from '@service/RequestService';
import { queryNames } from '@utils/constants/queryNames';
import { useMutation, useQueryClient } from 'react-query';

export const useBuildingDuplicate = () => {
  const qc = useQueryClient();

  return useMutation<{ name: string; id: number }, any, { name: string; fromId: number }>(
    async data => {
      const res = await $api.post('/v1/building/duplicate', data);

      return res?.data?.data;
    },
    {
      onSuccess: () => {
        qc.invalidateQueries([queryNames.BUILDING_ID]);
      }
    }
  );
};
